import { SiteDetails, SiteUser } from '../../types/site.types'
import apiClient from '../apiClient'
import { ENDPOINTS } from '../endpoints'

export const siteService = {
  createToken: async (siteId: string): Promise<string> => {
    const response = await apiClient.post<string>(ENDPOINTS.sites.createToken(siteId))
    return response.data
  },

  listUsers: async (siteId: string): Promise<SiteUser[]> => {
    const response = await apiClient.get<{ users: SiteUser[] }>(ENDPOINTS.sites.users.list(siteId))
    return response.data.users
  },

  assignUser: async (siteId: string, userId: string): Promise<void> => {
    await apiClient.post(ENDPOINTS.sites.users.assign(siteId), { userId })
  },

  removeUser: async (siteId: string, userId: string): Promise<void> => {
    await apiClient.delete(ENDPOINTS.sites.users.remove(siteId, userId))
  },

  fetchSiteDetails: async (siteId: string): Promise<SiteDetails> => {
    const response = await apiClient.get<SiteDetails>(ENDPOINTS.sites.get(siteId))
    return response.data
  },
}
